package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.Chevron_right: ImageVector
    get() {
        if (_chevron_right != null) {
            return _chevron_right!!
        }
        _chevron_right = Builder(name = "Chevron_right", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            group {
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(8.29f, 16.59f)
                    lineTo(12.88f, 12.0f)
                    lineTo(8.29f, 7.41f)
                    lineTo(9.71f, 6.0f)
                    lineTo(15.71f, 12.0f)
                    lineTo(9.71f, 18.0f)
                    lineTo(8.29f, 16.59f)
                    close()
                }
            }
        }
        .build()
        return _chevron_right!!
    }

private var _chevron_right: ImageVector? = null
